// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!./../../node_modules/.npminstall/css-loader/0.21.0/css-loader/index.js!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/style-rewriter.js?id=_v-b99673b2&file=affixDocs.vue!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=style&index=0!./affixDocs.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!./../../node_modules/.npminstall/style-loader/0.13.1/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!./../../node_modules/.npminstall/css-loader/0.21.0/css-loader/index.js!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/style-rewriter.js?id=_v-b99673b2&file=affixDocs.vue!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=style&index=0!./affixDocs.vue", function() {
			var newContent = require("!!./../../node_modules/.npminstall/css-loader/0.21.0/css-loader/index.js!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/style-rewriter.js?id=_v-b99673b2&file=affixDocs.vue!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=style&index=0!./affixDocs.vue");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/style-loader/0.13.1/style-loader!./~/.npminstall/css-loader/0.21.0/css-loader!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/style-rewriter.js?id=_v-b99673b2&file=affixDocs.vue!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=style&index=0!./docs/example/affixDocs.vue
// module id = 178
// module chunks = 0